import { Check } from '@staccx/bento'
import { GenericTextInput } from './Fields/GenericTextInput'
import { has } from 'lodash'

export function ApplicationCalculator({ onNext, ...props }) {
  const purchaseTypeOptions = [
    {
      value: 'loan',
      label: 'Loan'
    },
    {
      value: 'leasing',
      label: 'Leasing'
    }
  ]

  const loanTermsOptions = [
    {
      value: 36,
      label: '36 months'
    },
    {
      value: 48,
      label: '48 months'
    },
    {
      value: 60,
      label: '60 months'
    },
    {
      value: 72,
      label: '72 months'
    },
    {
      value: 84,
      label: '84 months'
    },
    {
      value: 96,
      label: '96 months'
    }
  ]

  const { trigger } = props
  async function handleNext() {
    const isValid = await trigger('calculator')
    if (!isValid) return
    onNext()
  }
  return (
    <div className="flex flex-col gap-6 justify-between min-h-[480px]">
      <div className="flex flex-col gap-6 popUp">
        <div className="flex flex-col gap-2">
          <label htmlFor="purchaseType" className="text-xs">
            Purchase Type
          </label>
          <div className="flex items-center gap-4">
            {purchaseTypeOptions.map((option) => {
              const typeSelected = props.watch('calculator.purchaseType')
              return (
                <button
                  type="button"
                  onClick={() => props.setValue('calculator.purchaseType', option.value)}
                  className={`${
                    typeSelected === option.value ? 'bg-primary text-background border-primary' : 'border-primary'
                  } w-full border-2 hover:rounded-xl transition-all ease-in-out rounded-md shadow-md p-4 flex items-center justify-center gap-4`}
                >
                  {option.label}
                  {typeSelected === option.value ? <Check /> : null}
                </button>
              )
            })}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-6">
          <GenericTextInput name="calculator.purchasePrice" label="Purchase Price" placeholder="0" type="number" />
          <GenericTextInput name="calculator.registrationFee" label="Registration Fee" placeholder="0" type="number" />
          <GenericTextInput name="calculator.downPayment" label="Down Payment" placeholder="0" type="number" />
          <GenericTextInput
            name="calculator.nominalInterestRate"
            label="Interest Rate (Nominal)"
            placeholder="0.0"
            type="number"
          />
        </div>
        <div className="flex flex-col gap-2">
          <label htmlFor="purchaseType" className="text-xs">
            Loan term (months)
          </label>
          <div className="flex items-center gap-4">
            {loanTermsOptions.map((option) => {
              const typeSelected = props.watch('calculator.loanTerms')
              return (
                <button
                  type="button"
                  onClick={() => props.setValue('calculator.loanTerms', option.value)}
                  className={`${
                    typeSelected === option.value ? 'bg-primary text-background border-primary' : 'border-primary'
                  } w-full border-2 rounded-md hover:rounded-xl transition-all ease-in-out shadow-md p-4 flex items-center justify-center gap-4`}
                >
                  {option.label}
                </button>
              )
            })}
          </div>
        </div>
        {/*  <div className="grid grid-cols-2 gap-4">
          <GenericTextInput
            name="calculator.calculatedResidualValue"
            label="Calculated Residual Value"
            placeholder="0"
            type="number"
          />
          <GenericTextInput name="calculator.feeIncVat" label="Fee Inc. VAT" placeholder="0" type="number" />
        </div> */}
      </div>
      <div className="flex w-full justify-end">
        <button
          type="button"
          onClick={() => handleNext()}
          className="bg-primary px-10 border-2 text-background border-primary rounded-md hover:rounded-xl transition-all ease-in-out shadow-md p-4 flex items-center justify-center gap-4"
        >
          Next
        </button>
      </div>
    </div>
  )
}
